export default {
  name: "EventConnections",
  props: ["editedEvent", "step", "position", "isOwnedBySubPrincipal"],
  data: () => ({
    types: ["poi-id", "news-id", "weather.com", "webcam", "mapping-id"]
  }),
  methods: {
    addItem() {
      if (this.additionalDataEmpty) this.editedEvent.additional_data = [];
      this.editedEvent.additional_data.push({});
    },
    removeItem(index) {
      this.editedEvent.additional_data.splice(index, 1);
    }
  },
  computed: {
    principal() {
      return this.$store.state.selectedPrincipal;
    },
    additionalDataEmpty() {
      return (
        !this.editedEvent.additional_data ||
        (this.editedEvent.additional_data &&
          !this.editedEvent.additional_data.length)
      );
    }
  }
};
